export default {"src":"/_next/static/media/address-book.88a11040.svg","height":21,"width":19};